import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import Fab from '@material-ui/core/Fab';
import Spinner from '../components/Spinner'
import { fieldErrors } from '../utils/errors'
import HeaderPlain from '../components/HeaderPlain'
import { graphql, StaticQuery, Link, navigate } from 'gatsby'
import {checkPhoneNumber, checkEmail, loginWithEmail, loginWithPhone} from '../utils/Helper'
import { logPage, logEvent, pushToDataLayer } from '../components/Analytics'

class Login extends React.Component{
    constructor(props){
        super(props)

        if(this.props.isUserLogin){
			navigate('/mina-sidor');
        }

        this.state = {
            loading: false,
            disabled: false,
            username: '',
            password: '',
            viewPassword: false,
            error: ''
        }
    }

    componentDidMount(){
        logPage()
	}

    handleChange = (e) => {
        this.setState({[e.target.name] : e.target.value.trim()});
    }

    showPassword = () => {
        this.setState({viewPassword : !this.state.viewPassword});
    }

    setError = (error) => {
        this.setState({error: error})
    }

    loadingPage = (status) => {
        this.setState({loading: status, disabled: status});
    }


    login = () => {
        const { username, password } = this.state;
        const { dispatchIsUserLogin, dispatchLoginUserDetails } = this.props;

        if(username === '' || password === ''){
            this.setError(fieldErrors.loginDetailEmpty)
            return false
        }

        this.loadingPage(true);

        if(checkEmail(username)){
            
            loginWithEmail(username, password, (data) => {
                console.log('call', data)
                if(data.status){
                    console.log('User Logged in')
                    if (typeof window !== `undefined`){
                        let userD = localStorage.getItem('userDetails');
                        let userData = JSON.parse(userD);
                        if(userData && userData.hasOwnProperty('uid')){
                            dispatchIsUserLogin(true);
                            dispatchLoginUserDetails(userData);
                            navigate('/mina-sidor');
                        }
                    }
                }
                else{
                    this.loadingPage(false);
                    this.setError(fieldErrors.incorrectLogin)
                }
            });
        }
        else if(checkPhoneNumber(username)){
            loginWithPhone(username, password, (data) => {
                console.log('call', data)
                if(data.status){
                    console.log('User Logged in')
                    if (typeof window !== `undefined`){
                        let userD = localStorage.getItem('userDetails');
                        let userData = JSON.parse(userD);
                        if(userData && userData.hasOwnProperty('uid')){
                            dispatchIsUserLogin(true);
                            dispatchLoginUserDetails(userData);
                            navigate('/mina-sidor');
                        }
                    }
                }
                else{
                    this.loadingPage(false);
                    this.setError(fieldErrors.incorrectLogin)
                }
            });
        }
        else{
            this.setState({error: 'Vi kunde inte hitta en användare med de uppgifterna du uppgav. Vänligen försök igen eller använd "glömt lösenord"-funktionen.'})
        }

    }

    render(){
        const { eyes,eyeShow } = this.props.query;
        const { loading, disabled, username, password, viewPassword, error } = this.state;

        return(
            <Fragment>
                <HeaderPlain logoColor="#46e2b9" headerClass="login-header" title="Albert" />
                <section className="login-middle">
                    <div className="custom-container">
                        <div className="login-form">
                            <h3>Logga in på Mina Sidor</h3>
                            <div className="form-group">
                                <label>Telefonnummer eller E-post</label>
                                <input type="text" placeholder="Telefonnummer eller E-post" name="username" value={username} onChange={e => this.handleChange(e)}/>
                            </div>
                            <div className="form-group">
                                <label>Lösenord</label>
                                <input type={viewPassword ? 'text' : 'password'} name="password" placeholder="Lösenord"  value={password} onChange={e => this.handleChange(e)}/>
                                <span className="eyes" onClick={this.showPassword}><img src={viewPassword ? eyes.publicURL :eyeShow.publicURL }/></span>
                            </div>
                            <p><Link to="/forgot-password" onClick={(e) => {
                                        logEvent(
                                            `Login page Glömt lösenordet button`,
                                            `Login page Glömt lösenordet button was clicked`
                                        )
                                        pushToDataLayer(
                                            'userClick',
                                            'Login Page Glömt Lösenordet Button',
                                            'Login Page Glömt Lösenordet Button Was Clicked',
                                        )
                                }}>Glömt lösenordet?</Link></p>
                        
                            <Fab
                                variant="extended"
                                color="primary"
                                aria-label="Add"
                                className="registerButton login-btn"
                                disabled={disabled}
                                onClick={(e) => {
                                        this.login(e);
                                        logEvent(
                                            `Login page Logga in button`,
                                            `Login page Logga in button was clicked`
                                        )
                                        pushToDataLayer(
                                            'userClick',
                                            'Login Page Logga In Button',
                                            'Login Page Logga In Button Was Clicked',
                                        )
                                    }
                                }
                                >
                                Logga in
                            </Fab>
                            {
                                loading && (
                                    <Spinner size={48}/>
                                )
                            }

                            <p style={{color: 'red', margin: '2rem 0 0 0'}}>{error}</p>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

const reducerProp = (state) => {
	return {
		isUserLogin: state.isUserLogin
	}
}

const reduxDispatch = dispatch => {
    return { 
        dispatchLoginUserDetails: (status) => dispatch({ type: `LOGIN_USER_DETAILS`, value: status }),
        dispatchIsUserLogin: (status) => dispatch({ type: `IS_USER_LOGIN`, value: status }),
    }
}
const ConnectRedux = connect(reducerProp, reduxDispatch)(Login)

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    eyes: file(relativePath: {regex: "/eyes/"}) {
                        publicURL
                    }
                    eyeShow: file(relativePath: {regex: "/eye-password/"}) {
                        publicURL
                    }                   
                }`
            }
        render={(data)  => (
           <ConnectRedux query={data} {...props}/>
        )}
    />
)